import { getBsaSarStatusLabel } from './getBsaSarStatusLabel'

interface Props {
  name: string
}

export const BsaSarStatusLabel = ({ name }: Props) => <span>{getBsaSarStatusLabel(name)}</span>
